import React from "react";
import classNames from "classnames";
import styles from "./MarkupDisplay.scss";
import { PropTypes } from "prop-types";

export const MarkupDisplay = ({ children, html, contrast }) => {
    const createMarkup = () => {
        return html
            ? {
                  __html: html
              }
            : null;
    };

    return (
        <div
            className={classNames(styles.base, {
                [styles.contrast]: contrast
            })}
        >
            <div className={styles.wrapper} dangerouslySetInnerHTML={createMarkup()}>
                {children}
            </div>
        </div>
    );
};

MarkupDisplay.propTypes = {
    /**
     * Wraps components that should be styled by this display (mostly only used by the editor)
     */
    children: PropTypes.any,
    /**
     * HTML to render with the display styles
     */
    html: PropTypes.string,
    /**
     * Light markup on dark background
     */
    contrast: PropTypes.bool
};
